import { push } from 'connected-react-router';
import { isRSAA, RSAA } from 'redux-api-middleware';
import { getToken, getAuditToken, getUser } from '../utils/auth';
import { FETCH_EXPECTATIONS_SUCCESS } from '../actions/expectations';

const auth = store => next => action => {
  // if user is not authenticated, make sure to redirect them to homepage
  if (
    action.type === '@@router/LOCATION_CHANGE' &&
    action.payload.location.pathname !== '/' &&
    !getUser()
  ) {
    store.dispatch(push('/'));
    return null;
  }

  const token = action.type === FETCH_EXPECTATIONS_SUCCESS ? getAuditToken() : getToken();

  // If user is logged in, we need to append user access token to all api requests
  if (isRSAA(action)) {
    const { options } = action[RSAA];
    const isFileUpload = options ? options.isFileUpload : false;

    // Check for file upload and don't pass
    // due to GitHub Issue: https://github.com/agraboso/redux-api-middleware/issues/125
    if (options && isFileUpload) {
      // eslint-disable-next-line no-param-reassign
      action[RSAA].headers = {
        ...action[RSAA].headers,
        Authorization: `Bearer ${token}`,
      };
    } else {
      // eslint-disable-next-line no-param-reassign
      action[RSAA].headers = {
        ...action[RSAA].headers,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      };
    }
    const impersonatedUserOidFromLS = localStorage.getItem('impersonatedUserOid');
    if (impersonatedUserOidFromLS) {
      // eslint-disable-next-line no-param-reassign
      action[RSAA].headers = {
        ...action[RSAA].headers,
        impersonatedUserOid: `${impersonatedUserOidFromLS}`,
      };
    }
  }

  return next(action);
};

export default auth;
